document.addEventListener('DOMContentLoaded', function () {
  const burgerButton = document.getElementById('button-burger');
  const menu = document.getElementById('menu');

  burgerButton && burgerButton.addEventListener('click', function() {
    menu.classList.toggle('show');
  })

  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      })
    })
  })

  const wentAboard = (parentElem, childElem) => {
    const parentRect = parentElem.getBoundingClientRect();
    const childRect = childElem.getBoundingClientRect();

    return childRect.left < parentRect.left || childRect.right > parentRect.right;
  };

  const hideWhenOutOfBounds = (container, elem) =>
    wentAboard(container, elem) ? elem.classList.add('hide') : elem.classList.remove('hide');

  new WOW().init();

  new Swiper('.giftset-collections', {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.giftset-tabs .tabs-menu',
      type: 'bullets',
      clickable: true,
      bulletClass: 'tab',
      bulletActiveClass: 'active',
      renderBullet: function(index) {
        return `<li class="tab">${index + 1}</li>`;
      },
    }
  })

  new Swiper('.coffee-products', {
    spaceBetween: 30,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '#coffee-button-next',
      prevEl: '#coffee-button-prev',
    },
  }).on('transitionEnd', () => {
    const coffeeProductsContainer = document.getElementsByClassName('coffee-products')[0]
    const coffeeCards = document.querySelectorAll('.coffee-products .short-product-card');

    coffeeCards.forEach((item) => {
      hideWhenOutOfBounds(coffeeProductsContainer, item);
    });
  });

  new Swiper('.coffee-combo-products', {
    spaceBetween: 30,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '#coffee-combo-button-next',
      prevEl: '#coffee-combo-button-prev',
    },
  }).on('transitionEnd', () => {
    const coffeeComboProductsContainer = document.getElementsByClassName('coffee-combo-products')[0]
    const coffeeComboCards = document.querySelectorAll('.coffee-combo-products .product-card');

    coffeeComboCards.forEach((item) => {
      hideWhenOutOfBounds(coffeeComboProductsContainer, item);
    });
  });
});
